import React from "react";
import { PopupWrapper, Overlay } from "./popup.styled";

const CustomPopup = ({
  message,
  onPrimary,
  onSecondary,
  primaryBtnText = "OK",
  secondaryBtnText = "Back",
  showOverlay = true,
}) => {
  return (
    <>
      {showOverlay && <Overlay onClick={onSecondary} />}
      <PopupWrapper>
        <div className="content">
          <div className="text">{message}</div>
          <div className="button-container">
            <button className="secondary-btn" onClick={onSecondary}>
              {secondaryBtnText}
            </button>
            <button className="primary-btn" onClick={onPrimary}>
              {primaryBtnText}
            </button>
          </div>
        </div>
      </PopupWrapper>
    </>
  );
};

export default CustomPopup;
